import React from 'react';
import { Box } from '@mui/material';

import { MaterialPropertyValuePair } from '@paragon/client-tools';
import { AnalogModel, AnalogPanel } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';
import { notNullish } from '@paragon/utilities';

import assertNotNullish from '../../../../library/utilities/assertNotNullish';
import { getAnalogModelForActiveComponentDesign } from '../../../../store/selectors/getAnalogModelForActiveComponentDesignSelector';
import { getDistanceFormatterSelector } from '../../../../store/selectors/getDistanceFormatterSelector';
import { useAppSelector } from '../../../hooks';

interface Props {
  analogPanel: AnalogPanel;
}

export const getAnalogPanelLength = (panel: AnalogPanel, analogModel: AnalogModel) =>
  panel.linkGuids
    .map((linkGuid) => analogModel.analogLinks.find((link) => link.guid === linkGuid))
    .filter(notNullish)
    .reduce((length, link) => length + link.length, 0);

export function AnalogPanelProperties(props: Props) {
  const analogModel = useAppSelector(getAnalogModelForActiveComponentDesign);
  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);

  if (!assertNotNullish(analogModel)) return null;

  const length = getAnalogPanelLength(props.analogPanel, analogModel);

  return (
    <PropertiesPanel title="Panel Properties">
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <MaterialPropertyValuePair sx={{ m: 1, flex: 1 }} property="Length" value={distanceFormatter(length)} />
        <MaterialPropertyValuePair sx={{ m: 1, flex: 1 }} property="Name" value={props.analogPanel.name} />
      </Box>
    </PropertiesPanel>
  );
}
